import React, { useEffect, useMemo, useState } from 'react';
import { Typography } from '@guildeducationinc/recess';
import { RadioButtonSet } from 'src/components/Quiz/RadioButtonSet';
import { Footer } from 'src/components/Quiz/Footer';
import { trackEvent } from 'src/services/analytics';
import { QuizQuestion } from 'src/components/Quiz/QuizQuestion';
import {
	AnswerKeys,
	GpaRanges,
	QuizAnalytics,
	ScreenProps,
} from '@src/containers/QuizContainer/types';
import { useQuiz } from '@src/components/Providers/QuizProvider';
import styles from './HighSchoolGpa.module.scss';

export const values: { label: GpaRanges; disabled: boolean }[] = [
	{ label: GpaRanges.threePointFive, disabled: false },
	{ label: GpaRanges.threePointZero, disabled: false },
	{ label: GpaRanges.twoPointFive, disabled: false },
	{ label: GpaRanges.twoPointZero, disabled: false },
	{ label: GpaRanges.onePointZero, disabled: false },
	{ label: GpaRanges.notSure, disabled: false },
];

const question = "What's your high school GPA?";

export const HighSchoolGpa: React.FC<ScreenProps> = props => {
	const { answers } = useQuiz();
	const { defaultAnswers, nextScreen, previousScreen, updateAnswers } = props;

	const defaultHsGpaAnswer = answers?.hsGpa ? answers.hsGpa : defaultAnswers?.hsGpa || undefined;
	const [hsGpaAnswer, setHsGpaAnswer] = useState<string>(defaultHsGpaAnswer);

	const analyticsData: QuizAnalytics = useMemo(() => {
		return {
			questionKey: question,
			questionType: 'radioButtons',
		};
	}, []);

	useEffect(() => {
		trackEvent('userProgramQuizQuestionAttempted', analyticsData);
	}, [analyticsData]);

	return (
		<>
			<fieldset className={styles.container} data-testid='hs-gpa'>
				<legend className={styles.title}>
					<QuizQuestion question={question} />
				</legend>
				<Typography className={styles.helperText} variant='body1'>
					Your grade point average (GPA) helps us determine what programs you qualify for. It
					doesn&apos;t have to be exact, and there are programs for everyone.
				</Typography>
				<RadioButtonSet onSelect={setHsGpaAnswer} options={values} value={hsGpaAnswer} />
			</fieldset>
			<Footer
				disableNext={!hsGpaAnswer}
				onClickNext={() => {
					analyticsData.responseKey = hsGpaAnswer;
					updateAnswers({ [AnswerKeys.hsGpa]: hsGpaAnswer }, answers);
					trackEvent('userProgramQuizQuestionCompleted', analyticsData);
					nextScreen();
				}}
				onClickPrevious={previousScreen}
			/>
		</>
	);
};
